import { BoilerAdapter, get_z3k_object_state, } from 'z3k-parser/model/z3k-config';
export function getModulationLevelFromBoilerAdapter(config, state, hc) {
    if (config != null) {
        for (const control_dev_id of hc.control_devices) {
            const boiler_adapter = BoilerAdapter.get.byId(config, control_dev_id);
            if (boiler_adapter != null) {
                const ba_state = get_z3k_object_state(state, boiler_adapter.id);
                if (ba_state != null) {
                    return ba_state.ot.rml ?? null;
                }
            }
        }
    }
    return null;
}
export function addBuiltInBoilerAdapter(device_spec, config, setter = {}) {
    //Беру все встроенные
    const exist_serial = new Set(BoilerAdapter.get
        .where(config, (ba) => ba.serial.builtIn)
        .map((ba) => ba.serial.value));
    let type = BoilerAdapter.default_object.type;
    let serial = BoilerAdapter.default_object.serial.value;
    let name = BoilerAdapter.default_object.name;
    if (device_spec.heating.has_heating) {
        for (const ba_spec of device_spec.heating.builtin_boiler_adapters) {
            if (!exist_serial.has(ba_spec.serial)) {
                serial = ba_spec.serial;
                type = ba_spec.default_protocol;
                name = ba_spec.name;
                break;
            }
        }
    }
    return BoilerAdapter.get.add(config, {
        ...BoilerAdapter.default_object,
        type: type,
        serial: {
            value: serial,
            builtIn: true,
        },
        name,
        ...setter,
    })[1];
}
export function findBoilerAdapterBySlot(config, slot) {
    return BoilerAdapter.get.one(config, (adapter) => adapter.slot == slot);
}
